import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';
const legacyFeeVariant = 67798237642930;
const root = window.Shopify.routes.root;
let pending;
async function request(path, body) {
  const response = await fetch(root + path, {method: body ? 'POST' : 'GET', headers: body ? {'Content-Type':'application/json'} : {}, body: body ? JSON.stringify(body) : undefined, credentials:'same-origin', cache:'no-store'});
  if (!response.ok) throw new Error('cart');
  return response.json();
}
function clearLegacyCartFee() {
  if (pending) return pending;
  pending = (async () => {
    const component = customElements.get('cart-items-component');
    while (component?.pendingQuantityUpdates?.length) await Promise.allSettled(component.pendingQuantityUpdates);
    let cart = await request('cart.js');
    const legacyLines = cart.items.filter(item => item.variant_id === legacyFeeVariant);
    if (!legacyLines.length) return;
    const updates = Object.fromEntries(legacyLines.map(item => [item.key, 0]));
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
    cart = await request('cart/update.js', {updates, attributes:{'Payment preference':''},sections,sections_url:location.pathname});
    const update = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[],promise:update.promise}));
    update.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:cart.sections,items:cart.items,itemCount:cart.item_count,source:'nct-legacy-fee-cleanup',didError:false}});
  })().finally(() => {pending = null;});
  return pending;
}
function reportError() {
  const panel = document.querySelector('nct-cart-payment');
  const status = panel?.querySelector('[data-nct-payment-status]');
  if (status) status.textContent = panel.dataset.error;
}
async function checkout(button) {
  button.disabled = true;
  try {await clearLegacyCartFee();location.assign(root+'checkout');}
  catch {reportError();button.disabled=false;}
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-nct-checkout]');
  if (!button) return;
  event.preventDefault();event.stopImmediatePropagation();checkout(button);
},true);
document.addEventListener('submit', event => {
  if (event.target.id !== 'cart-form' || !event.submitter?.matches('[data-nct-checkout]')) return;
  event.preventDefault();checkout(event.submitter);
},true);
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({detail}) => {if(detail?.source!=='nct-legacy-fee-cleanup') clearLegacyCartFee().catch(reportError);}).catch(()=>{});
});
clearLegacyCartFee().catch(reportError);
window.addEventListener('pageshow', event => {if(event.persisted) clearLegacyCartFee().catch(reportError);});
